import script from "./TheoryPaperExam.vue?vue&type=script&setup=true&lang=js"
export * from "./TheoryPaperExam.vue?vue&type=script&setup=true&lang=js"

import "./TheoryPaperExam.vue?vue&type=style&index=0&id=0457d220&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0457d220"]])

export default __exports__